import { render, staticRenderFns } from "./ResellersTable.vue?vue&type=template&id=4871103f"
import script from "./ResellersTable.vue?vue&type=script&lang=js"
export * from "./ResellersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports